// HTML-escape helper. Shared across ui modules to prevent player-controlled
// strings (MasterName, GirlfriendName, PlayerName, NPC dialog) from breaking
// template literals or enabling XSS via shared save-file exports.
//
// Saves are exchanged between players (bug-report flow, community translation
// editor, Patreon Discord). A poisoned save with `<img src=x onerror=...>`
// as a MasterName silently ships in the export and replays on the recipient's
// session. Self-XSS also breaks UX when a player picks "Master <3" — `<`
// truncates the line in markup parsers.
//
// Authoritative escape table — keep in sync with shop.js inline pattern
// (still used at shop.js:29-31 for compat; new sites should import from here).

const ESCAPE_MAP = { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#39;' };

/**
 * Escape an HTML-unsafe string for use in innerHTML / template-literal contexts.
 * @param {*} value — coerced to string (null/undefined → empty)
 * @returns {string}
 */
export function escapeHtml(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/[<>&"']/g, c => ESCAPE_MAP[c]);
}

/**
 * Sanitize a player-input name (PlayerName, MasterName, GirlfriendName).
 * Strips control chars + HTML-unsafe chars + caps length at maxLen.
 * @param {*} value
 * @param {number} [maxLen=30]
 * @returns {string}
 */
export function sanitizeName(value, maxLen = 30) {
    if (value === null || value === undefined) return '';
    return String(value)
        // strip control chars + HTML-unsafe chars at INPUT time so the escape
        // helper above never has to handle them at render time.
        .replace(/[\x00-\x1f<>&"'`\x7f]/g, '')
        .trim()
        .slice(0, maxLen);
}
